
export const products = {
  'product.categories': 'Catégories de produits',
  'explore.solutions': 'Explorez notre gamme complète de solutions audiovisuelles professionnelles',
  'view.video': 'Voir la vidéo de présentation du produit',
  'AV Over IP': 'AV Sur IP',
  'ReAX Control': 'Contrôle ReAX',
  'Meeting Room Solutions': 'Solutions pour Salles de Réunion',
  'Converters/Scalers': 'Convertisseurs/Scalers',
  'Audio Products': 'Produits Audio',
  'HDMI Switchers': 'Commutateurs HDMI',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'Produits HDBaseT',
  'Complete AV distribution solution with ultra-low latency': 'Solution complète de distribution AV à très faible latence',
  'Professional control system solutions': 'Solutions professionnelles de systèmes de contrôle',
  'Complete solutions for modern meeting spaces': 'Solutions complètes pour espaces de réunion modernes',
  'Professional format conversion and scaling solutions': 'Solutions professionnelles de conversion de format et de mise à l\'échelle',
  'Professional audio processing and playback solutions': 'Solutions professionnelles de traitement et de lecture audio',
  'Professional HDMI switching and distribution solutions': 'Solutions professionnelles de commutation et de distribution HDMI',
  'Advanced IP-based AV distribution platform': 'Plateforme avancée de distribution AV basée sur IP',
  'Professional HDBaseT distribution solutions': 'Solutions professionnelles de distribution HDBaseT',
  'group.not.found': 'Groupe non trouvé',
  'product.not.found': 'Produit non trouvé',
  'return.to.home': 'Retour à l\'accueil',
  'back.to.product.group': 'Retour au groupe de produits',
  'overview': 'Aperçu',
  'full.description': 'Description complète',
  'features': 'Fonctionnalités',
  'specifications': 'Spécifications',
};
